import { useEffect, useState } from 'react';
import { ANNOUNCEMENTS } from '../../data/announcements';
import useCurrency from '../../hooks/useCurrency';

/* Announcement copy carries {{price.<plan>}} tokens rather than a literal
   figure, because this bar links straight to /pricing — showing a US visitor
   "from ₹299" and then a USD checkout is the exact mismatch the pricing page
   was built to avoid. useCurrency resolves instantly from the browser timezone
   and re-confirms server-side, so there is no flash of the wrong currency. */
function resolvePrice(html, symbol, price) {
  return html.replace(/\{\{price\.(\w+)\}\}/g, (_, plan) => `${symbol}${price(plan)}`);
}

export default function Announcement() {
  const [idx, setIdx] = useState(0);
  const [visible, setVisible] = useState(true);
  const { symbol, price } = useCurrency();

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;
    const id = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIdx((i) => (i + 1) % ANNOUNCEMENTS.length);
        setVisible(true);
      }, 250);
    }, 7000);
    return () => clearInterval(id);
  }, []);

  const item = ANNOUNCEMENTS[idx];

  return (
    <div className="announce">
      <a
        href={item.href}
        style={{ opacity: visible ? 1 : 0, transition: 'opacity .25s' }}
        dangerouslySetInnerHTML={{ __html: resolvePrice(item.html, symbol, price) }}
      />
    </div>
  );
}
